/**
* LL JS
* -----------------------------------------------------------------------------
*
* This is the core of the LLJS system. It's a combination of a couple things,
* DOM-based routing, module-export pattern, and component-driven development.
*
* The goal is to allow component JS to exist within the component's folder
* and only firing if that component is being used on the page.
*/
window.debounce = require( 'lodash/debounce' );
window.throttle = require( 'lodash/throttle' );
window.Vue = require( 'vue' );
import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
// import VueDatePicker from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css';
import Vuex from 'vuex';

Vue.use( Vuex );

// Vue.component( 'example', require( './components/Example.vue' ).default );
// Vue.component( 'buy-tickets', require( './components/BuyTickets.vue' ).default );
// Vue.component( 'buy-membership', require( './components/BuyMembership.vue' ).default );
// Vue.component( 'buy-merchandise', require( './components/BuyMerchandise.vue' ).default );
// Vue.component( 'buy-gift-cards', require( './components/BuyGiftCards.vue' ).default );
Vue.component( 'checkout', require( './components/Checkout.vue' ).default );
Vue.component( 'nav-event-calendar', require( './components/NavEventCalendar.vue' ).default );
Vue.component( 'nav-event-calendar-mobile', require( './components/NavEventCalendarMobile.vue' ).default );
Vue.component( 'cart-login', require( './components/CartLogin.vue' ).default );
Vue.component( 'events-search', require( './components/EventsSearch.vue' ).default );
Vue.component( 'calendar', Calendar );
Vue.component( 'date-picker', DatePicker );

const store = new Vuex.Store( {
  state: {
    updateCounter: 0, // used to keep the single event sidebar working
    isLoggedIn: false,
    selectedEvent: false,
    nextSessionDate: false,
    selectedMerchandise: false,
  },
  mutations: {
    setLoginState( state, n ) {
      state.isLoggedIn = n;
    },
    setSelectedEvent( state, {n, date} ) {
      state.selectedEvent = n;
      state.nextSessionDate = date;
      state.updateCounter++;
    },
    setSelectedMerchandise( state, {n, date} ) {
      state.selectedMerchandise = n;
    },
  },
} );

export default store;

// const vueAppBuyMembership = new Vue( {
//   el: '#buy-membership',
//   store: store,
// } );

// const vueAppBuyTickets = new Vue( {
//   el: '#buy-tickets',
//   store: store,
// } );

// const vueAppBuyGiftCards = new Vue( {
//   el: '#buy-gift-cards',
//   store: store,
// } );

// const vueAppSidebarCart = new Vue( {
//   el: '#sidebar-cart',
//   store: store,
// } );

// const vueAppBuyMerchandise = new Vue( {
//   el: '#buy-merchandise',
//   store: store,
// } );

if ( $( '#ticketure-checkout' ).length ) {
  const vueAppCheckout = new Vue( {
    el: '#ticketure-checkout',
    store: store,
  } );
}

if ( $( '#events-search' ).length ) {
  const vueAppCheckout = new Vue( {
    el: '#events-search',
    store: store,
  } );
}

const vueAppNavbar = new Vue( {
  el: 'header.navbar',
  store: store,
} );

( function( $ ) {
  const arrayUnique = function( a ) {
    return a.reduce( function( p, c ) {
      if ( p.indexOf( c ) < 0 ) {
        p.push( c );
      }
      return p;
    }, [] );
  };

  /**
   * The main app.
   *
   * @type {Object}
   */
  const app = {

    components: {},

    registerComponent: function( componentName, component ) {
      this.components[componentName] = component;
    },
  };

  window.app = app;

  // Global variable on the window that returns true if prefers reduced motion is turned off
  window.hasMotion = window.matchMedia( '(prefers-reduced-motion: no-preference)' ).matches;

  window.isMobile = ! window.matchMedia( '(min-width: 768px)' ).matches;
  window.previouslyMobile = window.isMobile;

  $( window ).on( 'resize', debounce( function() {
    window.isMobile = ! window.matchMedia( '(min-width: 768px)' ).matches;
    if ( window.isMobile !== window.previouslyMobile ) {
      window.previouslyMobile = window.isMobile;
      $( document ).trigger( 'updateMediaQuery' );
    }
  }, 100 ) );

  window.toggleGridOverlay = function() {
    const template = `<div id="gridOverlay" class="fixed inset-0 z-50 opacity-25 pointer-events-none">
        <div class="container grid grid-cols-6 md:grid-cols-8 lg:grid-cols-12 gap-gutter-full h-full">
          <div class="h-full" style="background-color: #fc8181;"></div>
          <div class="h-full" style="background-color: #fc8181;"></div>
          <div class="h-full" style="background-color: #fc8181;"></div>
          <div class="h-full" style="background-color: #fc8181;"></div>
          <div class="h-full" style="background-color: #fc8181;"></div>
          <div class="h-full" style="background-color: #fc8181;"></div>
          <div class="hidden md:block h-full" style="background-color: #fc8181;"></div>
          <div class="hidden md:block h-full" style="background-color: #fc8181;"></div>
          <div class="hidden lg:block h-full" style="background-color: #fc8181;"></div>
          <div class="hidden lg:block h-full" style="background-color: #fc8181;"></div>
          <div class="hidden lg:block h-full" style="background-color: #fc8181;"></div>
          <div class="hidden lg:block h-full" style="background-color: #fc8181;"></div>
        </div>
      </div>`;
    if ( document.getElementById( 'gridOverlay' ) ) {
      document.getElementById( 'gridOverlay' ).remove();
    } else {
      document.body.insertAdjacentHTML( 'beforeend', template );
    }
  };

  // The routing fires all common scripts, followed by the component-specific
  // scripts. Add additional events for more control over
  // timing e.g. a finalize event
  const UTIL = {
    fire: function( func, funcname, args ) {
      let fire;
      const namespace = app.components;
      funcname = ( funcname === undefined ) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if ( fire ) {
        namespace[func][funcname]( args );
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire( 'common' );

      let components = [];

      $( '[data-component]' ).each( function( index, el ) {
        components.push( $( this ).attr( 'data-component' ) );
      } );

      components = arrayUnique( components );

      // Fire component-specific init JS, and then finalize JS
      $.each( components, function( i, classnm ) {
        UTIL.fire( classnm );
        UTIL.fire( classnm, 'finalize' );
      } );

      // Fire common finalize JS
      UTIL.fire( 'common', 'finalize' );
    },
  };

  // Load Events
  $( document ).ready( UTIL.loadEvents );
} )( jQuery );
